import MDBox from "components/MDBox"
import Icon from "@mui/material/Icon"

function HeadingIcon({
  color,
  icon,
  ...rest
}: {
  color: string
  icon: string
  [key: string]: any
}): React.ReactElement {
  return (
    <MDBox
      variant="gradient"
      bgColor={color}
      color={color === "light" ? "dark" : "white"}
      coloredShadow={color}
      borderRadius="xl"
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="8rem"
      height="8rem"
      mt={-3}
      {...rest}
    >
      <Icon sx={{ fontSize: "60px !important" }} color="inherit">
        {icon}
      </Icon>
    </MDBox>
  )
}

export default HeadingIcon
